module.exports = __webpack_public_path__ + "img/SERVICECOMBMESHER.ab9efb20.png";